import { timelineTracker } from '../../fingo/components/MuiTimeline';

const MuiTimeline = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...timelineTracker({
        theme,
        accent: theme.palette.secondary.A400,
        accentBg: theme.palette.secondary.A100,
        captionColor: theme.palette.gray.A500,
      }),
    }),
  },
};

export default MuiTimeline;
